import getSymbolFromCurrency from 'currency-symbol-map'
import { Skeleton } from 'primereact/skeleton'
import React from 'react'
import CurrencyFormat from '../../../../components/CurrencyFormat'
import { useTranslation } from 'react-i18next';
import UOMConversion from '../../../../components/UOMConversion';



const PriceUI = React.memo(
    ({ PriceDetails, priceClass="text-2xl" }) => {
        const priceBold = 600;
        const { t } = useTranslation();



        return (
            <>
                {PriceDetails.Status === "Loading" &&
                    <>
                        <Skeleton width="10rem" className="mb-2"></Skeleton>
                        <Skeleton width="5rem" className="mb-2"></Skeleton>
                    </>
                }
                {(PriceDetails.Status === "BasePrice" || PriceDetails.Status === "CSPPrice") &&
                    <div className="w-100">
                        {getSymbolFromCurrency(PriceDetails.ProductPriceCurrencyCode)}
                        <span className={priceClass} style={{ fontWeight: priceBold, color: "var(--sidebar-color)", }}>
                            {parseFloat(PriceDetails.ProductPrice).toFixed(2)}
                        </span>
                        <span style={{ fontSize: "70%" }} className='capitalize'>
                            {" "}({parseInt(PriceDetails.ProductPriceQuantity)}{" "}
                            <UOMConversion UOMCode={PriceDetails.ProductPriceQuantityCode} />)
                        </span>
                    </div>
                }

                {PriceDetails.Status === "Discount" &&
                    <div className="flex flex-column w-100 ">
                        <div>
                            <strike style={{ fontSize: '13px' }} >
                                {getSymbolFromCurrency(PriceDetails.ProductPriceCurrencyCode)}
                                {PriceDetails.ProductPrice.toFixed(2)} {" "}
                            </strike>

                            {getSymbolFromCurrency(PriceDetails.ProductPriceCurrencyCode)}

                            <span style={{ fontWeight: priceBold, color: "var(--sidebar-color)", }}
                                className={priceClass}
                            >
                                {CurrencyFormat(Math.abs(parseFloat(PriceDetails.ProductPrice - ((PriceDetails.DiscountPercentage / 100) * PriceDetails.ProductPrice))))}
                            </span>

                            <span style={{ fontSize: "70%" }} className='capitalize'>
                                {" "}({parseInt(PriceDetails.ProductPriceQuantity)}  {" "}
                                <UOMConversion UOMCode={PriceDetails.ProductPriceQuantityCode} />)
                            </span>
                        </div>

                        <div className="mt-1 d-flex justify-content-start align-items-center gap-2">
                            <div className="saved-amount border-round-sm">
                                {t('Save')} : {getSymbolFromCurrency(PriceDetails.ProductPriceCurrencyCode)}
                                {CurrencyFormat(parseFloat((Math.abs(parseFloat(PriceDetails.DiscountPercentage)) / 100) * parseFloat(PriceDetails.ProductPrice)))}
                            </div>
                            <span className="discount-badge"
                            >
                                {Math.abs(parseFloat(PriceDetails.DiscountPercentage))}%{t('off')}
                            </span>
                        </div>

                    </div>
                }

            </>
        )
    }
)

export default PriceUI